import { safeDefineElement } from '@/scripts/functions'
import { AccountToggle, CustomerAddresses, PasswordField } from '@/scripts/customer/customer'
import { FacetToggle } from '@/scripts/content/facets'
//import { UcoastWishlist } from '@/scripts/customer/UcoastWishlist'

window.onload = () => {
	typeof CustomerAddresses !== 'undefined' && new CustomerAddresses()
}
function initialize() {
	safeDefineElement(PasswordField)
	safeDefineElement(AccountToggle)
	safeDefineElement(FacetToggle)
	//safeDefineElement(UcoastWishlist)
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initialize)
} else {
	initialize()
}
